import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { nth } from '../../../../utils';

const Items = (props) => {

  const { data = [] } = props;
  
  return (
    <ReactTable
      className='-striped -highlight'
      data={data}
      columns={[
        nth,
        {
          Header: 'Group',
          accessor: 'group',
          maxWidth: 50
        },
        {
          Header: 'Try',
          accessor: 'attempt',
          maxWidth: 50
        },
        {
          Header: 'MatchId',
          accessor: 'matchId',
          maxWidth: 50
        },
        {
          Header: 'Begin',
          accessor: 'beginTime',
          maxWidth: 60
        },
        {
          Header: 'End',
          accessor: 'endTime',
          maxWidth: 60
        },
        {
          Header: 'Robot #',
          accessor: 'robotNumber',
          maxWidth: 70
        },
        {
          Header: 'Robot name',
          accessor: 'robotName',
          maxWidth: 200
        },
        {
          Header: 'Team name',
          accessor: 'name',
          maxWidth: 200
        },
        {
          Header: 'Result Unit',
          accessor: 'resultUnit',
          maxWidth: 120
        },
        {
          Header: 'Match Type',
          accessor: 'matchType',
          maxWidth: 120
        },
        {
          Header: 'Source ID',
          accessor: 'sourceId',
          maxWidth: 120
        }
      ]}
      /* defaultSorted={[ */
      /*   { id: 'beginTime', desc: false }, */
      /*   { id: 'matchId', desc: false } */
      /* ]} */
      pageSize={data.length}
      showPagination={false}
    />
  );
};

export default Items;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/Tables/Items/index.js